import { required } from 'vuelidate/lib/validators'
import formValidator from '@/mixins/form-validator.js'
import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import sessionStore from '@/stores/session-store.js'
import parentRoute from '@/mixins/parent-route.js'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'

export default {
  name: 'VerifyPhoneModal',
  extends: BaseModal,
  mixins: [formValidator, CurrentUserResolver, PrefixesMixin, parentRoute],
  data: function () {
    return {
      errors: {},
      submitted: false,

      user: {
        phone: '',
        phonePrefix: '',
      },

      blocker: false,
      validatedItemKey: 'user',
    }
  },
  watch: {
    currentUser: {
      handler: function () {
        this.user.phone = this.currentUser.phone
        this.user.phonePrefix = this.currentUser.phonePrefix
      },
      deep: true,
    },
  },
  computed: {
    inputValuesChanged() {
      return (
        this.user.phone != this.currentUser.phone ||
        this.user.phonePrefix != this.currentUser.phonePrefix
      )
    },
  },
  methods: {
    save: function (e) {
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'put',
          url: `users/${this.currentUser.id}`,
          data: {
            user: {
              phone: this.user.phone,
              phonePrefix: this.user.phonePrefix,
            },
          },
        })
          .then(response => {
            sessionStore.commit('setUser', response.data)
            this.sendVerificationCode()
            localStorage.setItem('verificationCodeSent', 'true')
          })
          .catch(error => {
            let errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
          })
          .finally(() => {
            this.blocker = false
          })
      }
    },

    sendVerificationCode: function () {
      if (!!this.currentUser && !!this.currentUser.id) {
        this.blocker = true
        axios({
          method: 'put',
          url: `users/${this.currentUser.id}/start_phone_verification`,
          data: {
            id: this.currentUser.id,
          },
        })
          .then(response => {
            sessionStore.commit('setUser', response.data)
            this.$router.push('verification')

            toastStore.commit('success', {
              message:
                this.$t('profile.phone.verification.resendCodeMessage') +
                ` +${response.data.phonePrefix} ${response.data.phone}`,
            })
            this.blocker = false
            this.close(true)
          })
          .catch(error => {
            let errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            this.blocker = false
          })
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          phone: {
            required,
          },
          phonePrefix: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
